import React, { Component } from 'react';
class getLocalesACtivos extends Component {
  constructor(props){
    super(props)
    this.state = {
        sucursales:''
      }
  }
  generar_tabla(){
    const sucursales = this.state.sucursales
    return(
        <table style={{"width":"500px"}} className='tb_pedidos'>
            <thead>
                <tr>
                    <th>
                        Sucursal
                    </th>
                    <th>
                        Estado
                    </th>
                </tr>
            </thead>
            <tbody>
                {(sucursales)?
                sucursales.map(sucursal => (
                    <tr>
                        <td>
                            {sucursal.sucursales}
                        </td>
                        <td>
                            {sucursal.activo}
                        </td>
                    </tr>
                ))
                :null}
            </tbody>
        </table>
    )
  }
  regresar =()=>{
    this.props.get_salir_vista_pedido()
  }
  getvalidar =()=>{
    const url= this.props.dir_url + "webapp/getSucursalesAct";
    const token =  this.props.token
    var obj = { accion:'sucursalesact', token };
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(obj),
      headers:{
        'Accept':'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(res => res.json())
    .then((data) => {
      //console.log(data[0].msg)
      if(data[0].status==="ok"){
        if(data[0].msg[0].base==="bd_app_lcr"){
          this.setState({
            sucursales :data[0].msg
          })
        }else{
          this.setState({
            sucursales :data[0].msg
          })
        }
        
      }
    })
    .catch(console.log)
  }
  render() {

    return(
      <React.Fragment>
        <div className="cssversion_menu cssversion_colorwhite" style={{"color":"black"}}>
            <div className="cssversion_pw100 cssversion_ph10 cssversion_colorblanco" style={{"display":"flex"}}>
            <div className="cssversion_pw10 cssversion_contentCenter" onClick={ () => this.regresar()}>
                <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/12355707351582004488-128.png') } />
            </div>
            <div className="cssversion_pw90 cssversion_contentCenter" >
               
            </div>
            </div>
            <div className="cssversion_pw100 cssversion_ph90" style={{"display":"flex"}}>
                 {this.generar_tabla()}
            </div>
        </div>
      </React.Fragment>
    )
  }

  componentDidMount (){
    this.getvalidar()
  }


}
export default getLocalesACtivos;
